module.exports = __webpack_public_path__ + "static/media/home-analytics-background.33b64592.svg";